import * as React from 'react';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { I18nextProps } from '@pec/aion-ui-i18next/types/i18n';
import { withTranslation } from 'react-i18next';

export const styles = (theme: Theme) =>
  createStyles({
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25)
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto'
      }
    },
    searchIcon: {
      width: theme.spacing(5),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    inputRoot: {
      color: 'inherit',
      width: '100%'
    },
    inputInput: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(5),
      transition: theme.transitions.create('width'),
      width: '100%'
    }
  });

export type Props = WithStyles<typeof styles>;

type State = {
  searchTerm: string;
};

class CompanySearchComponent extends React.Component<Props & I18nextProps, State> {
  constructor(props: Props & I18nextProps) {
    super(props);
    this.state = {
      searchTerm: ''
    };
  }

  handleSubmit = () =>
    window.location.assign(`/SSQV4/SSQAdminFindCompany.aspx?company=${encodeURIComponent(this.state.searchTerm)}`);

  handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      this.handleSubmit();
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    this.setState({ searchTerm: event.currentTarget.value });

  render() {
    const { classes, t } = this.props;
    return (
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder={t('components.companySearch.searchForACompany', 'Search for a Company…')}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput
          }}
          onChange={this.handleChange}
          onKeyUp={this.handleKeyUp}
        />
      </div>
    );
  }
}

export const CompanySearch = withStyles(styles)(withTranslation()(CompanySearchComponent));
